import script from "./heroAir.vue?vue&type=script&setup=true&lang=js"
export * from "./heroAir.vue?vue&type=script&setup=true&lang=js"

import "./heroAir.vue?vue&type=style&index=0&id=80bf3648&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80bf3648"]])

export default __exports__